<template>
  <div>
    <h1 class="text-center">Service Master</h1>
    <div>
      <ListServiceMaster />
    </div>
  </div>
</template>

<script>
import ListServiceMaster from "./ListServiceMaster.vue";
export default {
  components: {
    ListServiceMaster,
  },
};
</script>
